import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button, Box, Typography, Paper, Divider, Alert } from '@mui/material';

const Login = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '80vh' 
    }}>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 500, width: '100%', textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Tervetuloa Purkupojat Palautussovellukseen
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ mb: 3 }}>
          Kirjaudu sisään jatkaaksesi
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={() => {
            // Ohjaa suoraan Auth0-kirjautumiseen ohittaen SDK:n välimuistin
            const domain = 'dev-ppy1fc543jivoo30.us.auth0.com';
            const clientId = '0SB2iycAdWVlPY6a9par0fe476lA5B71';
            const redirectUri = encodeURIComponent(`${window.location.origin}/callback`);
            const audience = encodeURIComponent('https://api.purkuapp.fi');
            
            // Lisätään aikaleima estämään välimuistin käyttöä
            const timestamp = new Date().getTime();
            
            // Rakennetaan URL suoraan pakottaen käyttäjätunnus/salasana -kirjautuminen
            // prompt=login pakottaa kirjautumislomakkeen näyttämisen
            // connection=Username-Password-Authentication pakottaa käyttäjätunnus/salasana -kirjautumisen
            // login_hint täyttää sähköpostikentän valmiiksi
            const url = `https://${domain}/authorize` + 
              `?client_id=${clientId}` +
              `&response_type=code` +
              `&redirect_uri=${redirectUri}` +
              `&audience=${audience}` +
              `&scope=openid%20profile%20email` +
              `&connection=Username-Password-Authentication` +
              `&prompt=login` +
              `&login_hint=testipurkupojat@testi.fi` +
              `&ui_locales=fi` +
              `&auth0Client=${encodeURIComponent(JSON.stringify({name:'auth0-spa-js',version:'2.0.0'}))}` +
              `&cache=${timestamp}`;
            
            // Ohjataan suoraan kirjautumissivulle
            window.location.href = url;
          }}
          size="large"
          sx={{ mb: 3 }}
        >
          Kirjaudu sisään
        </Button>
        
        <Divider sx={{ my: 3 }} />
        
        <Alert severity="info" sx={{ mt: 2, textAlign: 'left' }}>
          <Typography variant="subtitle2" gutterBottom>
            Testitunnukset:
          </Typography>
          <Typography variant="body2">
            Sähköposti: <strong>testipurkupojat@testi.fi</strong><br />
            Salasana: <strong>testi123testi123!</strong>
          </Typography>
        </Alert>
      </Paper>
    </Box>
  );
};

export default Login;
